// Global, non-blocking toast for 403 responses. fetchWithAuth dispatches an
// "app:forbidden" window event whenever a guarded endpoint returns 403; this
// listener (mounted once in App) surfaces the server's message without crashing
// the screen. UI gating should prevent most 403s — this is the safety net.

import { useEffect, useState } from "react";
import MDSnackbar from "components/MDSnackbar";

function ForbiddenSnackbar() {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    const handler = (event) => {
      setMessage(event.detail || "You do not have permission to perform this action.");
      setOpen(true);
    };
    window.addEventListener("app:forbidden", handler);
    return () => window.removeEventListener("app:forbidden", handler);
  }, []);

  const close = () => setOpen(false);

  return (
    <MDSnackbar
      color="error"
      icon="warning"
      title="Access denied"
      content={message}
      dateTime=""
      open={open}
      onClose={close}
      close={close}
      bgWhite
    />
  );
}

export default ForbiddenSnackbar;
